<!--TODO: make dialog wider (see specific custom-dialog classes for this) -> check with design/growpony for common width/style of dialogs and try to apply as generic as possible!-->
<!--TODO: to make this as generic as possible for dialogs, move this header into a directive or component with title as param-->
<div mat-dialog-title class="d-flex align-items-baseline justify-content-between">
  <h2 class="flex-grow-1" translate>FILTER.TITLE</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon svgIcon="close_v2"></mat-icon>
  </button>
</div>
<mat-dialog-content class="container-max d-flex flex-column">
  @if (topics$ | async; as topics) {
    <div class="topics-wrapper">
      <p class="headline" translate>FILTER.HEADER</p>
      <div class="d-flex flex-column">
        @for (topic of topics; track topic) {
          <mat-checkbox (change)="toggleFilterSelection(topic.id)" [checked]="topic.selected" color="primary">
            {{ getTopicTitle(topic) }}
          </mat-checkbox>
        }
      </div>
      <button mat-button class="mt-2 mx-3" color="primary" (click)="selectAllTopics()">
        <span translate>FILTER.SELECT_ALL</span>
      </button>
    </div>
  }
  <div class="languages-wrapper">
    <label class="headline" id="radio-label-language-select">{{ 'FILTER.LANGUAGE.HEADER' | translate }}</label>
    <mat-radio-group aria-labelledby="radio-label-language-select" class="d-flex flex-column" [(ngModel)]="selectedLanguage">
      @for (lang of languages; track lang) {
        <mat-radio-button [value]="lang" (change)="selectLanguage(lang)" color="primary">
          <span translate>FILTER.LANGUAGE.{{ lang | uppercase }}</span>
        </mat-radio-button>
      }
    </mat-radio-group>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="deselectAllTopics()">
    <span translate>FILTER.SELECT_NONE</span>
  </button>
  <button mat-flat-button color="primary" (click)="close()">
    <span translate>FILTER.OK</span>
  </button>
</mat-dialog-actions>
